export default __webpack_public_path__ + "static/2-dashboard-d0b0a5bfb24e65073862bc404f3a3822.jpg";